module.exports = __webpack_public_path__ + "static/media/checked2.5796bbd3.png";